import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { Navbar } from "@/components/Navbar";
import Landing from "@/pages/Landing";
import BookSlot from "@/pages/BookSlot";
import MyBookings from "@/pages/MyBookings";
import Admin from "@/pages/Admin";

const TOAST_OPTIONS = {
  style: {
    background: "#121212",
    color: "#FFFFFF",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "2px",
  },
};

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white font-body">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/book" element={<BookSlot />} />
          <Route path="/my-bookings" element={<MyBookings />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Toaster position="top-right" toastOptions={TOAST_OPTIONS} />
      </BrowserRouter>
    </div>
  );
}

export default App;
